import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';

import Carousel from 'react-bootstrap/Carousel';
import Alert from 'react-bootstrap/Alert';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';

const today = Date.now();

const NotificationsCarousel = () => {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [notificationData, setNotificationData] = useState([{}]);

  const handleSelect = selectedIndex => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    fetch('./data/notifications.json')
      .then(response => response.json())
      .then(json => {
        setNotificationData(json.filter(notification => Date.parse(notification.expirests) > today));
      });
  }, []);

  return (
    <>
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        interval={null}
        className="carousel-notifications"
        indicators={notificationData.length > 1}
        controls={notificationData.length > 1}
      >
        {notificationData.map(item => (
          <Carousel.Item
            key={`item-${item.id}`}
            style={{ background: 'none' }}
          >
            <Carousel.Caption key={`caption-${item.id}`}>
              <Alert variant={item.critical ? 'danger' : 'warning'}>
                <span className="position-absolute pos-top pos-right p-4 mr-6 d-none d-sm-block">
                  <Moment format="dddd, MMM DD, YYYY">
                    {item.createdts}
                  </Moment>
                </span>
                <div className="d-flex">
                  <div className="ml-4 mr-3 width-8">
                    <span className="fa-stack fa-2x">
                      <i className="fal fa-shield fa-stack-2x" />
                      <i className={item.critical ? 'fas fa-exclamation fa-stack-1x' : 'fas fa-info fa-stack-1x'} />
                    </span>
                  </div>
                  <div className="mb-4 mr-6">
                    <span className="h2">{item.title}</span>
                    <span className="d-block d-sm-none">
                      <Moment format="dddd, MMM DD, YYYY">
                        {item.createdts}
                      </Moment>
                    </span>
                    <br />
                    {item.intro}
                    {item.message && (
                      <>
                        &nbsp;
                        <Button
                          name="btnReadMoreNotifications"
                          key={item.id}
                          variant={item.critical ? 'danger' : 'warning'}
                          onClick={() => setOpen(!open)}
                          aria-controls={item.id}
                          aria-expanded={open}
                          className="mt-1 mb-2 mr-2 ml-0"
                          size="sm"
                        >
                          {open ? (
                            <>
                              Read Less
                              <i className="far fa-chevron-up ml-2" />
                            </>
                          ) : (
                            <>
                              Read More
                              <i className="far fa-chevron-down ml-2" />
                            </>
                          )}
                        </Button>
                        <Collapse id={item.id} in={open}>
                          {/* eslint-disable-next-line react/no-danger */}
                          <div dangerouslySetInnerHTML={{ __html: item.message }} />
                        </Collapse>
                      </>
                    )}
                  </div>
                </div>
              </Alert>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
};

export default NotificationsCarousel;
